export default "__VITE_ASSET__f6d55fa4__"